@if (loaded) {
  <form [formGroup]="form" novalidate action="#">
    @if (integrationSrcType?.logo_description_image_url) {
      <tidy-row>
        <tidy-image
          class="hero-size"
          [src]="integrationSrcType?.logo_description_image_url" />
      </tidy-row>
    }
    @if (activeIntegrations?.length > 0) {
      <tidy-row>
        <tidy-text
          [header]="('Active ' | translate) + integrationSrcType?.name + (' Integrations' | translate)" />
      </tidy-row>
    }
    @for (integration of activeIntegrations; track integration) {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          @if (integration?.guest_reservation_source_type?.format === 'api') {
            <tidy-image
              [src]="'assets/img/gold-link.svg'"
              class="header-size" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
            <tidy-image
              [src]="'assets/img/concierge.svg'"
              class="header-size" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
            <tidy-image
              [src]="'assets/img/ical.png'"
              class="header-size" />
          }
          <tidy-text
            [header]="integration.guest_reservation_source_type?.name | titlecase" />
        </tidy-row>
        <tidy-row>
          @if (integration?.guest_reservation_source_type?.format === 'api') {
            <tidy-text
              [body]="'Direct Integration'" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
            <tidy-text
              [body]="'Concierge Integration'" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
            <tidy-text
              [body]="'iCal Integration'" />
          }
        </tidy-row>
        @if (integration?.guest_reservation_source_type?.format === 'icalendar' && integration?.url) {
          <tidy-row>
            <tidy-text
              [body]="'iCal Link: ' + integration?.url.slice(0, 30) + '..'"
              [translate]="false" />
            <tidy-image
              matTooltip="Copy iCal Link"
              [src]="'assets/icon/copy-circle-black.svg'"
              class="title-size"
              style="cursor: pointer; position: absolute; margin-top: -3px; margin-left: 10px;"
              (click)="copyToClipboard(integration?.url)" />
          </tidy-row>
        }
        @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
          <tidy-row>
            @if (integration?.address?.address_name) {
              <tidy-text
                [translate]="false"
                [body]="integration?.address?.address_name" />
            }
            @if (!integration?.address?.address_name && integration?.address?.address1) {
              <tidy-text
                [translate]="false"
                [body]="integration?.address?.address1 + ' ' + (integration?.address?.address2 || '')" />
            }
          </tidy-row>
        }
        @if (integration.last_sync_at) {
          <tidy-row>
            <tidy-text
              body="Last checked " />
            <tidy-text
              [body]="integration.last_sync_at | parseDateTime: 'MMM d'" />
          </tidy-row>
        }
        @if ((integration?.guest_reservation_source_type?.format ==='api' && integration.addresses.length > 0)) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              body=" Synced addresses:" />
            @for (adress of integration.addresses; track adress; let last = $last) {
              @if (adress?.address_name) {
                <tidy-text
                  [body]="' ' + adress.address_name"
                  [translate]="false" />
              } @else {
                @if (!adress?.address2 && adress?.address1) {
                  <tidy-text
                    [body]="' ' + adress.address1"
                    [translate]="false" />
                }
                @if (adress?.address2 && adress?.address1) {
                  <tidy-text
                    [body]="' ' + adress.address1 + ' ' + adress.address2"
                    [translate]="false" />
                }
              }
              @if (!last) {
                <tidy-text
                  [body]="','" />
              }
              @if (last) {
                <tidy-text
                  [body]="'.'" />
              }
            }
          </tidy-row>
        }
        @if (integration?.guest_reservation_source_type?.format !== 'concierge_integration') {
          @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length <= 0) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                body="Sync Pending.." />
            </tidy-row>
          }
          @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length > 0) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                body="Syncing guest reservations.." />
            </tidy-row>
          }
        }
      </tidy-card>
    }
    @if (!isUpdatingIntegration) {
      @if (pendingIntegrations?.length > 0) {
        <tidy-row>
          <tidy-text
            [header]="('Pending ' | translate) + integrationSrcType?.name + (' Integrations' | translate)" />
        </tidy-row>
      }
      @for (integration of pendingIntegrations; track integration) {
        <tidy-card>
          @if (integration.format === 'lock') {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/integration-images/remote-lock.png'"
                class="header-size" />
              <tidy-text
                [header]="'RemoteLock'"
                [translate]="false" />
            </tidy-row>
          }
          @if (integration.format === 'notification') {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/integration-images/' + integration?.integration?.channel + '.svg'"
                class="header-size" />
              <tidy-text
                [header]="integration?.integration?.channel === 'webhook' ? 'Webhook' : 'Slack'"
                [translate]="false" />
            </tidy-row>
          }
          @if (integration.format !== 'notification' && integration.format !== 'lock') {
            <tidy-row class="vertical-align-center">
              @if (integration.state !== 'paused') {
                <ion-spinner name="lines" class="card-loading-spinner" />
              }
              @if (integration.state === 'paused') {
                <tidy-image
                  [src]="'assets/img/action-needed.svg'"
                  class="header-size" />
              }
              <tidy-text
                [header]="integration.guest_reservation_source_type?.name | titlecase" />
            </tidy-row>
            <tidy-row>
              @if (integration?.guest_reservation_source_type?.format === 'api') {
                <tidy-text
                  [body]="'Direct Integration'" />
              }
              @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
                <tidy-text
                  [body]="'Concierge Integration'" />
              }
              @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                <tidy-text
                  [body]="'iCal Integration '" />
              }
            </tidy-row>
          }
          @if (integration.state !== 'paused' && integration?.guest_reservation_source_type?.format !== 'concierge_integration') {
            @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length <= 0) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  body="Sync Pending.." />
              </tidy-row>
            }
            @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length > 0) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  body="Syncing guest reservations.." />
              </tidy-row>
            }
          }
          @if (integration.state === 'paused') {
            <tidy-row>
              <tidy-text
                body="There was an issue syncing this integration. Please update your integration details." />
            </tidy-row>
          }
        </tidy-card>
      }
    }
    @if ((activeIntegrations?.length > 0 || pendingIntegrations?.length > 0) && !isUpdatingIntegration) {
      <tidy-row>
        <tidy-text
          [header]="('Add Another ' | translate) + integrationSrcType?.name + (' Integration' | translate)" />
      </tidy-row>
    }
    <tidy-card style="padding: 10px; flex-grow: 1; display: flex; flex-direction: column;">
      <div style="flex-grow: 1; display: flex; flex-direction: column;">
        <tidy-row style="flex-grow: 1;">
          <ion-row style="height: 100%;">
            <ion-col size="3" style="margin: auto">
              <tidy-image
                [src]="integrationSrcType?.logo_url"
                style="width:100%; max-height: 65px" />
            </ion-col>
            <ion-col style="display: flex; flex-direction: column;">
              <tidy-row class="vertical-align-middle">
                <tidy-text
                  [header]="integrationSrcType?.name"
                  [translate]="false" />
                @if (integrationSrcType?.discount) {
                  <tidy-image
                    [src]="'assets/img/coupon.svg'"
                    style="margin-left: 10px; width: 20px" />
                  <tidy-text
                    [body]="integrationSrcType?.discount" />
                }
                @if (integrationSrcType?.guest_reservation_source_type?.tidy_help_link) {
                  <tidy-image
                    (click)="goToIntegrationDocumentation(integrationSrcType?.guest_reservation_source_type?.tidy_help_link)"
                    [src]="'assets/svg/information-circle.svg'"
                    class="sync-circle-img"
                    style="margin-left: 5px"
                    [matTooltip]="'View Documentation' | translate" />
                }
              </tidy-row>
              @if (integrationSrcType?.short_description !== null) {
                <tidy-row style="flex-grow: 1;">
                  <tidy-text
                    [body]="integrationSrcType?.short_description" />
                </tidy-row>
              }
            </ion-col>
          </ion-row>
        </tidy-row>
      </div>
      @if (!onlyShowDirectIntegration && !isUpdatingIntegration) {
        <tidy-row class="extra-top-padding extra-bottom-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row [alignLastItemRight]="integrationSrcType?.tidy_help_link" [class.vertical-align-center]="!integrationSrcType?.tidy_help_link">
          <tidy-text
            [header]="'How do you want to integrate?'" />
          @if (integrationSrcType?.tidy_help_link) {
            <tidy-text
              (action)="goToHelp()"
              body="Get Help"
              class="link" />
          }
        </tidy-row>
        <tidy-row>
          <tidy-radio-button
            formControlName="integrationOption"
            [form]="form.controls.integrationOption"
            [items]="integrationOptionItems"
            [submitted]="submitted"
            [errorMessage]="'Please select an option.'"
            (optionChange)="updateFormValidation($event)" />
        </tidy-row>
      }
      <tidy-row class="extra-top-padding extra-bottom-padding vertical-align-center">
        <tidy-image
          [src]="getSelectedFormatIcon()"
          class="title-size" />
        <tidy-text
          [header]="getSelectedFormatHeader()" />
      </tidy-row>
      @if (longDescription) {
        <tidy-row [ngClass]="{'extra-bottom-padding': isDirectFormRequired || reservationSrc?.last_sync_at || form.value.integrationOption === 'icalendar' || form.value.integrationOption === 'concierge_integration' || form.value.integrationOption === 'zapier'}">
          <tidy-markdown [markdownContent]="longDescription" />
        </tidy-row>
      }
      @if (isDirectFormRequired && form.value.integrationOption === 'api') {
        @if (isBaseURLRequired) {
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="baseURL"
              [form]="form.controls.baseURL"
              [icon]="'assets/svg/globe.svg'"
              [label]="'Base URL'"
              [errorMessage]="'Please enter a valid base URL.'"
              [submitted]="submitted" />
          </tidy-row>
        }
        @if (isAccountIdRequired && integrationSrcType.name !== 'Guesty') {
          <tidy-row [ngClass]="isBaseURLRequired ? 'field-top-padding field-bottom-padding' : 'field-bottom-padding'">
            <tidy-input
              formControlName="accountId"
              [form]="form.controls.accountId"
              [icon]="'assets/svg/person-circle.svg'"
              [label]="getClientIdFieldHeader()"
              [errorMessage]="'Please enter a valid ID.'"
              [submitted]="submitted" />
          </tidy-row>
        }
        <tidy-row [ngClass]="isAccountIdRequired ? '' : 'field-top-padding'">
          <tidy-input
            formControlName="apiKey"
            [form]="form.controls.apiKey"
            [icon]="'assets/svg/key.svg'"
            [label]="getApiKeyFieldHeader()"
            [errorMessage]="'Please enter a valid API key.'"
            [submitted]="submitted" />
        </tidy-row>
      }
      @if ((integration?.state === 'paused' || integration?.state === 'active') && !isTidySource) {
        <tidy-row class="text-center extra-bottom-padding">
          <tidy-text
            [helper]="'You\’ve already added this integration for this property.  Please select a different property or '" />
          <tidy-text
            [body]="'Disable this Integration'"
            (action)="deactivateIntegration()"
            class="red link" />
        </tidy-row>
      }
      @if (form.value.integrationOption === 'icalendar') {
        <tidy-row class="field-top-padding field-bottom-padding">
          <tidy-input
            formControlName="importUrl"
            [form]="form.controls.importUrl"
            [icon]="'assets/svg/globe.svg'"
            label="iCal link"
            [errorMessage]="'Please enter a valid url'"
            [submitted]="submitted" />
        </tidy-row>
        @if (addressesSelectItems.length > 0) {
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/home.svg'"
              [label]="'Property'"
              [form]="form.controls.addressId"
              formControlName="addressId"
              [items]="addressesSelectItems" />
          </tidy-row>
        }
        @if (addressesSelectItems.length == 0) {
          <tidy-row>
            <tidy-text
              [body]="'Please add properties before integrating with iCal. '" />
            <tidy-text
              [body]="'Add Properties'"
              (action)="goToAddProperty()"
              class="link" />
          </tidy-row>
        }
      }
      @if (form.value.integrationOption === 'concierge_integration') {
        <tidy-row>
          <tidy-input
            formControlName="conciergeLogin"
            [form]="form.controls.conciergeLogin"
            [icon]="'assets/svg/person.svg'"
            [label]="'Username'"
            [errorMessage]="'Please enter a username'"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="conciergePassword"
            [form]="form.controls.conciergePassword"
            [icon]="'assets/svg/lock-closed.svg'"
            [label]="'Password'"
            [errorMessage]="'Please enter a password'"
            type="password"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row>
          <tidy-textarea
            formControlName="conciergeNotes"
            [form]="form.controls.conciergeNotes"
            [icon]="'assets/svg/create.svg'"
            [label]="'Notes'" />
        </tidy-row>
      }
      @if (form.value.integrationOption === 'zapier') {
        <tidy-row>
          <tidy-text
            class="link"
            [body]="'See Zapier for more details.'"
            (action)="goToZapier()" />
        </tidy-row>
      }
    </tidy-card>
    @if (isSelfBookingFlow) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/smartphone.svg'"
            class="title-size" />
          <tidy-text
            [header]="'Contact Information'" />
        </tidy-row>
        <tidy-row class="field-top-padding">
          <tidy-input-international-phone
            formControlName="phone"
            [label]="'Phone'"
            [form]="form.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.'"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
      </tidy-card>
    }
    <tidy-button
      [text]="getPrimaryButtonTitle()"
      [action]="boundAddReservationSource"
      [disabled]="(form.value.integrationOption === 'zapier' || alreadyAddedIntegration) || (addressesSelectItems.length == 0 && form.value.integrationOption === 'icalendar')"
      class="primary" />
    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }
  </form>
}

@if (!loaded) {
  <tidy-card style="padding: 0; height: 1000px;" class="no-padding">
    <ion-skeleton-text animated style="width: 100%; height: 1000px; margin: 0; border-radius: 6px;" />
  </tidy-card>
}
